import { render, staticRenderFns } from "./OfficialSignature.vue?vue&type=template&id=5b1d22f4"
import script from "./OfficialSignature.vue?vue&type=script&lang=ts"
export * from "./OfficialSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports